import axiosInstance from "../axiosInstance/axiosInstance";
import { CreateAlertReadEventRequest } from "./CreateAlertReadEventRequest";
import { GetUserReadAlertRequest } from "./GetUserReadAlertRequest";
import { UserReadAlertMapper } from "./UserReadAlertMapper";
import { UserReadAlertsResponse } from "./UserReadAlertsResponse";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addAlertReadEventAsync = createAsyncThunk(
  "alerts/addAlertReadEvent",
  async (request: CreateAlertReadEventRequest) => {
    const response = await axiosInstance.post<UserReadAlertsResponse>(
      `/userReadAlerts`,
      request
    );

    const userReadAlertMapper = new UserReadAlertMapper();
    return userReadAlertMapper.toUserReadAlerts(response.data);
  }
);

export const loadUserAlertReadAsync = createAsyncThunk(
  "alerts/loadUserAlertRead",
  async (request: GetUserReadAlertRequest) => {
    const response = await axiosInstance.get<UserReadAlertsResponse>(
      `/userReadAlerts?alertType=${request.alertType}`
    );

    if (!response.data) {
      return null;
    }
    const userReadAlertMapper = new UserReadAlertMapper();
    return userReadAlertMapper.toUserReadAlerts(response.data);
  }
);
